import { BodyRenderExternalData } from '~/components/BodyRender/models';
import { fluidGridMapper } from '~/mappers/fluidGrid';

import { SearchResults } from './models';

export const searchResultsMapper = (
  {
    header: {
      mode,
      description: { pending, results, noResults, emptyPhrase },
      descriptionSize,
      phraseTag,
      phraseSize,
      hiddenHeadline,
      popularSearchesDescription,
      popularSearchesSize,
    },
    resultsTabButton,
    productTabButton,
    articleTabButton,
    resourceTabButton,
    eventTabButton,
    moreResultsButtonLabel,
    moreProductsButtonLabel,
    moreArticlesButtonLabel,
    moreResourcesButtonLabel,
    moreEventsButtonLabel,
    initialVisibleItems,
    imageSettings,
    fluidGridUI,
    uid,
    ...rest
  }: SearchResults,
  _currentPageUid: string,
  { locale }: BodyRenderExternalData
) => ({
  header: {
    mode,
    description: {
      pending,
      results,
      noResults,
      emptyPhrase,
    },
    descriptionSize: descriptionSize?.toLowerCase(),
    phraseTag,
    phraseSize: phraseSize?.toLowerCase(),
    hiddenHeadline,
    popularSearchesDescription,
    popularSearchesSize: popularSearchesSize?.toLowerCase(),
  },
  resultsTab: resultsTabButton ?? 'All',
  productTab: productTabButton ?? 'Products',
  articleTab: articleTabButton ?? 'Articles',
  resourceTab: resourceTabButton ?? 'Resources',
  eventTab: eventTabButton ?? 'Events',
  moreResultsButtonLabel,
  moreProductsButtonLabel,
  moreArticlesButtonLabel,
  moreResourcesButtonLabel,
  moreEventsButtonLabel,
  initialVisibleItems,
  imageSettings,
  fluidGrid: fluidGridMapper(fluidGridUI[0]),
  locale,
  uid,
  ...rest,
});
